import { withCurrentParams } from 'actions/utils';
import { BROADCAST_DOWNLOAD_LIVE_RECORDING } from 'actions/Types';

/**
 * Download a recording
 * @param recording
 */

export default recording => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_DOWNLOAD_LIVE_RECORDING,
      request: async apiClient => {
        const { _id: recordingId } = recording;
        const { broadcast, eventDoc } = apiClient;

        if (recording.s3Key) {
          const broadcastResponse = await broadcast.getRecordingEventDoc(
            teamId,
            eventId,
            broadcastId,
            recordingId
          );

          if (broadcastResponse && broadcastResponse._id) {
            const eventDocResponse = await eventDoc.getSignedUrlPublic(
              teamId,
              eventId,
              broadcastResponse._id
            );

            if (eventDocResponse && eventDocResponse.url) {
              window.open(eventDocResponse.url);
            }
          }
        } else {
          const recordingResponse = await broadcast.getRecording(
            teamId,
            eventId,
            broadcastId,
            recordingId
          );

          if (recordingResponse && recordingResponse.url) {
            window.open(recordingResponse.url);
          }
        }

        return true;
      }
    };

    dispatch(action);
  });
};
